module.exports = __webpack_public_path__ + "img/vip-crown-fill.bf3ed3b1.svg";